import { Component, OnInit, Input } from '@angular/core';
import { DepotStockLocation } from '../../models/depot-stock-location.model';
import { Account } from '../../../order/models/account.model';
import { WarehouseLocation } from '../../../warehousing/models/warehouse-location.model';
import { AccountService } from '../../../account/services/account.service';
import { WarehouseLocationService } from '../../../warehousing/services/warehouse-location.service';
import { catchError, take } from 'rxjs/operators';

@Component({
    selector: 'app-depot-stock-location-form',
    templateUrl: './depot-stock-location-form.component.html',
    styleUrls: ['./depot-stock-location-form.component.scss'],
    standalone: false
})
export class DepotStockLocationFormComponent implements OnInit {

  @Input()
  depotStockLocation: DepotStockLocation;

  depots: Account[] = [];
  warehouseLocations: WarehouseLocation[] = [];

  constructor(
    private accountService: AccountService,
    private warehouseLocationService: WarehouseLocationService) { }

  ngOnInit(): void {
    this.accountService.getAllDepots()
    .pipe(catchError((e) => { alert('Depots could not be loaded'); return e; }))
    .pipe(take(1))
    .subscribe((depots: any) => {
      this.depots = depots;
      this.depots.push({id: -1, name: 'Select a depot...'} as any);
    });

    this.warehouseLocationService.getAllWarehouseLocations()
    .pipe(catchError((e) => { alert('Warehouse locations could not be loaded'); return e; }))
    .pipe(take(1))
    .subscribe((locations: WarehouseLocation[]) => {
      this.warehouseLocations = locations;
      this.warehouseLocations.push({id: -1, aisle: 'Select a location...', shelf: '', warehouse: {name: ''} as any} as any);
    });
  }

}
